<div class="_login-page">

	<div class="_flex-grow">
		<div class="_container">
			<div class="_login">
				<div class="_header">
					<img class="__logo" src="./assets/BEEGO_logo.png" />
					<p class="_title" [translate]="'LOGIN.INTRO'"></p>
				</div>

				<ng-container *ngIf="credentialsForm">

					<form [formGroup]="credentialsForm">
						<div class="_inputs">

							<ion-input name="username" [formControl]="credentialsForm.get('username') | cast" placeholder="{{ 'LOGIN.USERNAME' | translate}}" (keyup.enter)="login()">
								<ion-icon src="./assets/icons/user.svg"></ion-icon>
							</ion-input>
							<form-validation-error [control]="credentialsForm.get('username') | cast"></form-validation-error>
							
							<ion-input name="password" [formControl]="credentialsForm.get('password') | cast" [type]="passwordType" placeholder="{{ 'LOGIN.PASSWORD' | translate}}" (keyup.enter)="login()">
								<ion-icon src="./assets/icons/password.svg"></ion-icon>
								<ion-icon class="_show-password" src="./assets/icons/show-password-outline.svg" (click)="showPassword()"></ion-icon>
							</ion-input>
							<form-validation-error [control]="credentialsForm.get('password') | cast"></form-validation-error>
							
						</div>
					</form>
			
					<div class="_buttons">
						<button class="_button _login-button" (click)="login()" [disabled]="!credentialsForm.valid"><span [translate]="'LOGIN.LOGIN_BUTTON'" ></span></button>
						<div class="_below_button">
							<div class="_keep-me-logged-in">
								<ion-checkbox class="md" color="success" name="keepMeLoggedIn" [formControl]="credentialsForm.get('keepMeLoggedIn') | cast"></ion-checkbox>
								<ion-label [translate]="'LOGIN.KEEP_LOGGED_IN'"></ion-label>
							</div>
							<p class="_forgot-password" [translate]="'LOGIN.FORGOT_PASSWORD'" (click)="navigateToResetPassword()"></p>
						</div>
					</div>

				</ng-container>
			</div>


			<div class="_register-tenant">	

				<div class="_buttons">
					<button class="_button _register-button" (click)="navigateToRegisterTenant()"><span [translate]="'LOGIN.REGISTER_TENANT.REGISTER_BUTTON'" ></span></button>
				</div>

				<p class="_subtitle" >
					<b [translate]="'LOGIN.REGISTER_TENANT.TITLE'"></b>&nbsp;<span innerHTML="{{'LOGIN.REGISTER_TENANT.INTRO' | translate}}"></span> 
				</p>
		
			</div>	
		</div>
	</div>

	<logo-slider-component></logo-slider-component>

</div>
